module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kd-Lc.aed9ecee.png";